<template>
  <app-modal name="e-invoice-account-list-modal" :title="title"  @before-close="beforeClose" @before-open="beforeOpen" hide-footer>
    <div class="row mb-4">
      <div class="col-12 d-flex">
        <button class="btn btn-primary"
                :title="'Connect E-Invoice Provider'"
                @click="onClickConnect()">
          <i class="fal fa-fw fa-plus" aria-hidden="true"></i>
          {{$t('user.eAccountInvoice')}}
        </button>
        <button class="ml-auto btn btn-outline-secondary"
                :title="'Connect E-Invoice Provider'"
                @click="onClickSync()">
          <i class="fal fa-sync"></i>
          {{$t('user.sync')}}
        </button>
        <div class="sync-date">
          <v-date-picker
            style="display: inline-block; width: 7rem"
            v-model="syncDate"
            :popover="{ positionFixed: true, visibility: 'click' }"
          >
          </v-date-picker>
        </div>

      </div>
    </div>
    <app-table
      :pagination="false"
      :filter="false"
      :api-mode="false"
      :data="eInvoices"
      :fields="fields"
    >
      <div slot="status" slot-scope="props">
        <i style="color: green" class="fal fa-check" v-if="props.rowData.status" ></i>
        <i style="color: #a19f9f" class="fal fa-ban" v-if="!props.rowData.status" ></i>
      </div>
      <div slot="actions" slot-scope="props">
        <button class="btn btn-outline-primary btn-sm pb-0 pt-0"
                :title="'Active'"
                @click="onClickActive(props.rowData)">
          <i class="fal fa-fw fa-check" aria-hidden="true"></i>
        </button>
        <button class="btn btn-danger btn-sm pb-0 pt-0"
                :title="'Delete'"
                @click="onClickDelete(props.rowData)">
          <i class="fal fa-fw fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </app-table>
  </app-modal>
</template>

<script>
import AppTable from '@/components/app-table/';
import AppModal from '@/components/app-modal/';
import EInvoiceAccountProxy from '@/store/proxies/e-invoice-account-proxy';

export default {
  name: 'EInvoiceAccountModal',
  components: {
    AppModal,
    AppTable,
  },
  data() {
    return {
      title: this.$t('user.eAccountInvoice'),
      eInvoices: [],
      fields: [
        {
          name: 'id',
          title: 'Id',
        },
        {
          name: 'user_name',
          title: 'user.username',
        },
        {
          name: 'einvoice_provider',
          title: 'user.eAccountProvider',
        },
        {
          name: '__slot:status',
          title: 'user.status',
        },
        {
          name: '__slot:actions',
          titleClass: 'text-sm-right',
          dataClass: 'text-sm-right',
          title: 'app.action',
        },
      ],
      syncDate: new Date(),
    };
  },
  methods: {
    onClickSync() {
      if (this.syncDate) {
        new EInvoiceAccountProxy().syncEInvoices(this.syncDate);
      }
    },
    onClickActive(eInvoices) {
      new EInvoiceAccountProxy().activeEInvoiceAccount(eInvoices.id).then(() => {
        this.eInvoices.forEach((i) => {
          i.status = i.id === eInvoices.id;
        });
      });
    },
    onClickConnect() {
      this.$modal.show('e-invoice-account-modal', { model: {} });
    },
    onClickDelete(eInvoices) {
      this.$modal.show('dialog', {
        title: this.$t('user.deleteEAccountProvider'),
        text: this.$t('user.deleteEAccountConfirmMsg'),
        okText: this.$t('app.delete'),
        okClass: 'btn btn-danger btn-sm',
        onOk: () => {
          new EInvoiceAccountProxy().deleteEInvoiceAccount(eInvoices.id).then(() => {
            this.eInvoices = this.eInvoices.filter(r => r.id !== eInvoices.id);
          });
        },
      });
    },
    insertEInvoiceAccount(acc) {
      this.eInvoices.push(acc);
    },
    beforeClose() {
      this.syncDate = new Date();
      this.$bus.off('e-invoice-account-created', this.insertEInvoiceAccount);
    },
    beforeOpen() {
      this.$bus.on('e-invoice-account-created', this.insertEInvoiceAccount);
      new EInvoiceAccountProxy().getEInvoiceAccounts().then((response) => {
        this.eInvoices = response;
      });
    },
  },
};
</script>
<style>
.sync-date input {
  padding: 6px 10px 10px 10px;
  margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/e-invoice-account-list-modal.vue